<template>
    <section class="club-management main-body">

        <div class="clubs">
            <MiniHeader
                :heading="`Clubs - ${totalCount}`"
                :buttonText="'Add Clubs'"
                :hasButton="true"
                @buttonClicked="createClub()"
            >
                <router-link></router-link>
            </MiniHeader>

            <club-listing
                :clubs="clubs"
                :competitions="competitions"
                :inactive-clubs="inactiveClubs"
                :live-clubs="liveClubs"
            />
        </div>


        <router-view></router-view>

    </section>
</template>

<script>
import axios from "axios"
import MiniHeader from "../../components/Library/MiniHeader.vue"
import ClubListing from "./ClubListing.vue"
export default {
    name: "ClubManagement",

    components: {
        MiniHeader,
        ClubListing,
    },
    data: () => ({
        api: `${process.env.VUE_APP_CLUBSAPI}`,
        competitionsApi: `${process.env.VUE_APP_MULTICLUBMATCHESAPI}`,
        pageNumber: 1,
        pageSize: 100,
        pageCount: null,
        competitions: [],
        clubs: [],
        totalCount: 0,
        liveClubs: [],
        inactiveClubs: []
    }),
    
    mounted() {
        this.getClubs()
        this.getCompetitions()
    },
    methods: {
        getClubs() {
            this.$store.commit("startLoading");
            this.$getCurrentUserJwToken().subscribe((jwt) => {
                axios
                    .get(`${this.api}/pages?page.size=${this.pageSize}`, { "headers": { "Authorization": jwt } })
                    .then(response => {
                        this.clubs = response.data.data,
                        this.totalCount = response.data.meta.totalCount
                        this.pageCount = response.data.meta.totalPages
                        this.liveClubs = this.clubs.filter(item => item.attributes.club.hidden !== true)
                        this.inactiveClubs = this.clubs.filter(item => item.attributes.club.hidden === true);
                        this.$store.commit("completeLoading");
                    })
                    .catch(e => {
                        console.log("Unable to load teams:", e);
                        this.$store.commit("completeLoading");
                    })
            })
        },

        async getCompetitions() {
            const compIds = [10,11,12]

            const promises = []

            compIds.forEach(id => {
                console.log(id)
                promises.push(
                    new Promise((res, rej) => {
                        this.$getCurrentUserJwToken().subscribe((jwt) => {
                            axios({
                                method: "GET",
                                url: `${this.competitionsApi}/competitions/${id}`,
                                headers: { Authorization: jwt },
                            })
                            .then((response) => {
                                const competitionData = response.data.data;
                                console.log('Fetched competition:', competitionData.attributes);
                                res(competitionData.attributes);
                            })
                            .catch(e => {
                                console.log("Unable to load competitions:", e);
                                return rej()
                            })
                        })
                    })
                )
            })

            Promise.all(promises).then((competitions) => {
                console.log(competitions)
                this.competitions = competitions
            })

        },

        createClub () {   
            this.$router.push({
                name: "Create Club",
                path: "/club/create"
            })
        }
   }
}
</script>